import clsx from 'clsx'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

type TCardSummaryProps = React.HTMLAttributes<HTMLDivElement> & {
  title: string
  centered?: boolean
  changeButtonText?: string
  onChangeClicked?: () => void
}
export const CardSummary: React.FC<TCardSummaryProps> = ({
  title,
  centered,
  changeButtonText = 'Ubah',
  onChangeClicked,
  children,
}) => {
  return (
    <div>
      <div
        className={clsx(
          'flex items-center justify-between p-6 bg-expressive-dark-blue rounded-t-md',
          centered && '!justify-center'
        )}
      >
        <Text color="inverse" variant="heading-md">
          {title}
        </Text>

        {/** show "Ubah" button only when has "onChangeClicked" method */}
        {Boolean(onChangeClicked) && (
          <Button
            className="!bg-expressive-dark-blue"
            style={{ border: '1px solid #fff' }}
            onClick={onChangeClicked}
          >
            {changeButtonText}
          </Button>
        )}
      </div>
      {children}
    </div>
  )
}
